/* External dependencies */
import { Button, Icon } from 'atomize';
import React, { ReactNode } from 'react';

export interface ButtonProps extends Button {
  icon?: Icon;
  children?: ReactNode;
  dataTestId?: string;
  onClick: (item?: any) => void;
}

export function CustomButton(props: ButtonProps) {
  const { icon, children, dataTestId, onClick } = props;

  return (
    <Button
      m="0"
      p="2px"
      h="auto"
      bg="danger_color"
      hoverBg="danger_hover_text_color"
      {...props}
      data-testid={dataTestId || 'custom-button'}
      onClick={onClick}
    >
      {children}
      {icon && <Icon name="Minus" color="white" size="20px" {...icon} />}
    </Button>
  );
}
